export default [
  {
    path:"integrations",
    redirect: {name: "core-integration"}
  },
  {
    path: 'integrations/core',
    name: 'core-integration',
    component: () =>
      import('@/modules/integrations/views/core-system-list.vue')
  },
  {
    path: 'integrations/climate-risk-assessment',
    name: 'climate-risk-assessment-integration',
    component: () =>
      import('@/modules/integrations/views/climate-risk-assessment-list.vue')
  },
  {
    path: 'integrations/email-integration',
    name: 'email-integration',
    component: () =>
      import('@/modules/integrations/views/email-integration-list.vue')
  },
  {
    path: 'integrations/sms-integration',
    name: 'sms-integration',
    component: () =>
      import('@/modules/integrations/views/sms-integration-list.vue')
  },
  {
    path: 'integrations/whatsapp-integration',
    name: 'whatsapp-integration',
    component: () =>
      import('@/modules/integrations/views/whatsapp-integration-list.vue')
  },
  {
    path: 'integrations/integration-logs',
    name: 'integration-logs',
    component: () =>
      import('@/modules/integrations/views/integration-logs.vue')
  },
  {
    path: 'integrations/excel-extraction-mapping',
    name: 'excel-extraction-mapping',
    component: () => 
      import('@/modules/integrations/views/ExcelExtractionMap.vue')
  }
];
